import { ActionTree } from 'vuex';
import { IRootState } from '../root-state.store';
import { INotificationState } from './notification-state.store';
import {
  NOTIFICATION_GET_NOTIFICATIONS, NOTIFICATION_SET_UNREAD_NOTIFICATIONS,
  NOTIFICATION_MARKAS_READ, NOTIFICATION_CURRENT_CHANNEL, NOTIFICATION_GET_UNREAD,
  NOTIFICATION_GET_UNREAD_NOTIFICATIONS, NOTIFICATION_MARK_ALL_AS_READ, NOTIFICATION_DELETE_ALL,
  NOTIFICATION_SET_NOTIFICATIONS, NOTIFICATION_SET_NOTIFICATIONS_LOADING,
  NOTIFICATION_SET_NOTIFICATIONS_FAILED, NOTIFICATION_GET_NOTIFICATION_INFINITY_LOADING,
  NOTIFICATION_UPDATE_GET_NOTIFICATION_PARAMETER, NOTIFICATION_GET_UNREAD_NOTIFICATION_INFINITY_LOADING,
  NOTIFICATION_UPDATE_GET_UNREAD_NOTIFICATION_PARAMETER, NOTIFICATION_SET_UNREAD_NOTIFICATIONS_LOADING,
  NOTIFICATION_SET_UNREAD_NOTIFICATIONS_FAILED,
  NOTIFICATION_MARK_AS_READ_BY_ID
} from './notification-types.store';
import { ActivityStatus } from '../../common/enums';

export const actions: ActionTree<INotificationState, IRootState> = {

  [NOTIFICATION_GET_NOTIFICATIONS]: async ({ commit, state, getters }, merge: boolean = false) => {
    if (state.notifications.activityStatus === ActivityStatus.Loading)
      return

    commit(NOTIFICATION_SET_NOTIFICATIONS_LOADING)

    await state.service.getNotifications(state.notifications.searchParameter)
      .then(notifications => {
        commit(NOTIFICATION_SET_NOTIFICATIONS, {
          ...notifications,
          notificationIds: getters.notificationIds,
          merge: merge
        })
        return Promise.resolve(notifications)
      })
      .catch(error => {
        commit(NOTIFICATION_SET_NOTIFICATIONS_FAILED, error)
      })
  }

  , [NOTIFICATION_GET_UNREAD_NOTIFICATIONS]: async ({ commit, state, getters }, merge: boolean = false) => {

    if (state.unreadNotifications.activityStatus === ActivityStatus.Loading)
      return

    commit(NOTIFICATION_SET_UNREAD_NOTIFICATIONS_LOADING)

    await state.service.getNotifications(state.unreadNotifications.searchParameter)
      .then(res => {
        commit(NOTIFICATION_SET_UNREAD_NOTIFICATIONS, {
          ...res,
          notificationIds: getters.unreadNotificationIds,
          merge: merge
        })
      })
      .catch(err => {
        commit(NOTIFICATION_SET_UNREAD_NOTIFICATIONS_FAILED, err)
      })
  }
  , [NOTIFICATION_GET_NOTIFICATION_INFINITY_LOADING]: ({ commit, dispatch }) => {
    commit(NOTIFICATION_UPDATE_GET_NOTIFICATION_PARAMETER)
    setTimeout(() => {
      dispatch(NOTIFICATION_GET_NOTIFICATIONS, true)
    }, 100);
  }
  , [NOTIFICATION_GET_UNREAD_NOTIFICATION_INFINITY_LOADING]: ({ commit, dispatch }) => {
    commit(NOTIFICATION_UPDATE_GET_UNREAD_NOTIFICATION_PARAMETER)
    setTimeout(() => {
      dispatch(NOTIFICATION_GET_UNREAD_NOTIFICATIONS, true)
    }, 100);
  }
  , [NOTIFICATION_MARKAS_READ]: async ({ commit, dispatch, state }, channelId: string) => {

    commit(NOTIFICATION_CURRENT_CHANNEL, channelId);
    //if (getters.unreadNotifications.unreadCount > 0)
      await state.service.markAsRead(channelId)
        .then(res => {
          dispatch(NOTIFICATION_GET_UNREAD_NOTIFICATIONS)
        })
  }

  , [NOTIFICATION_MARK_ALL_AS_READ]: async ({ commit, state, getters, dispatch }) => {
    return await state.service.markAllAsRead()
      .then(res => {
        commit(NOTIFICATION_UPDATE_GET_UNREAD_NOTIFICATION_PARAMETER, 0)
        commit(NOTIFICATION_UPDATE_GET_NOTIFICATION_PARAMETER, 0)
        setTimeout(() => {
          dispatch(NOTIFICATION_GET_UNREAD_NOTIFICATIONS)
          dispatch(NOTIFICATION_GET_NOTIFICATIONS)
        }, 100);
        return res;
      })
      .catch(error => {
        return Promise.reject(error)
      })
  }

  , [NOTIFICATION_DELETE_ALL]: async ({ commit, state, getters, dispatch }) => {
    return await state.service.deleteAll()
      .then(res => {
        commit(NOTIFICATION_UPDATE_GET_UNREAD_NOTIFICATION_PARAMETER, 0)
        commit(NOTIFICATION_UPDATE_GET_NOTIFICATION_PARAMETER, 0)
        setTimeout(() => {
          dispatch(NOTIFICATION_GET_UNREAD_NOTIFICATIONS)
          dispatch(NOTIFICATION_GET_NOTIFICATIONS)
        }, 100);
        return res;
      })
      .catch(error => {
        return Promise.reject(error)
      })
  }
  , [NOTIFICATION_GET_UNREAD]: async ({ commit, state, getters }) => {
    await state.service.getUnreadNotification({ is_watched: false })
      .then(total => commit(NOTIFICATION_SET_UNREAD_NOTIFICATIONS, total))
  }
  , [NOTIFICATION_MARK_AS_READ_BY_ID]: async ({ commit, state, getters, dispatch }, id: any) => {
    await state.service.markAsReadForSingleItem(id)
      .then(res => {
        dispatch(NOTIFICATION_GET_UNREAD_NOTIFICATIONS)
      })
  }
}


// WEBPACK FOOTER //
// ./src/store/notification/notification-actions.store.ts